// client/src/services/adminMarketplaceService.js
import axios from '../utils/axiosConfig';

export const listPendingTherapists = (status) =>
  axios.get('/admin/therapists/pending', { params: { status } }).then(r => r.data.therapists);
export const reviewTherapist = (id, decision, rejectionReason) =>
  axios.put(`/admin/therapists/${id}/review`, { decision, rejectionReason }).then(r => r.data.profile);

export const listPendingVenues = (status) =>
  axios.get('/admin/venues/pending', { params: { status } }).then(r => r.data.venues);
export const reviewVenue = (id, decision, rejectionReason) =>
  axios.put(`/admin/venues/${id}/review`, { decision, rejectionReason }).then(r => r.data.profile);

export const listUsers = (params) => axios.get('/admin/users', { params }).then(r => r.data.users);
export const banUser = (id, reason) => axios.put(`/admin/users/${id}/ban`, { reason }).then(r => r.data);
export const unbanUser = (id) => axios.put(`/admin/users/${id}/unban`).then(r => r.data);
export const getUserWallet = (id) => axios.get(`/admin/users/${id}/wallet`).then(r => r.data);

export const listZones = () => axios.get('/admin/zones').then(r => r.data.zones);
export const createZone = (data) => axios.post('/admin/zones', data).then(r => r.data.zone);
export const updateZone = (id, data) => axios.put(`/admin/zones/${id}`, data).then(r => r.data.zone);
export const deleteZone = (id) => axios.delete(`/admin/zones/${id}`);

export const listServicesAdmin = () => axios.get('/admin/services').then(r => r.data.services);
export const createService = (data) => axios.post('/admin/services', data).then(r => r.data.service);
export const updateService = (id, data) => axios.put(`/admin/services/${id}`, data).then(r => r.data.service);
export const deleteService = (id) => axios.delete(`/admin/services/${id}`);

export const listMarketplaceOrders = (status) =>
  axios.get('/admin/marketplace-orders', { params: { status } }).then(r => r.data.orders);
export const getOrderDetail = (id) => axios.get(`/admin/marketplace-orders/${id}`).then(r => r.data);

export const listWithdrawals = (status) =>
  axios.get('/admin/withdrawals', { params: { status } }).then(r => r.data.requests);
export const markWithdrawalPaid = (id, manualReference, adminNotes) =>
  axios.put(`/admin/withdrawals/${id}/mark-paid`, { manualReference, adminNotes }).then(r => r.data.request);
export const processWithdrawalViaPaystack = (id) =>
  axios.put(`/admin/withdrawals/${id}/process-paystack`).then(r => r.data.request);
export const rejectWithdrawal = (id, adminNotes) =>
  axios.put(`/admin/withdrawals/${id}/reject`, { adminNotes }).then(r => r.data.request);

export const listFlaggedRatings = (reviewed) =>
  axios.get('/admin/flagged-ratings', { params: { reviewed } }).then(r => r.data.ratings);
export const resolveFlaggedRating = (id, action, banReason) =>
  axios.put(`/admin/flagged-ratings/${id}/resolve`, { action, banReason }).then(r => r.data.rating);

export const getDashboardStats = () => axios.get('/admin/dashboard-stats').then(r => r.data);
